var map = {
	"./decidim/avatar-multiuser.png": 7919,
	"./decidim/brands/facebook.svg": 38927,
	"./decidim/brands/google.svg": 96598,
	"./decidim/brands/twitter-x.svg": 1151,
	"./decidim/cc-badge.png": 83557,
	"./decidim/decidim-logo.svg": 65021,
	"./decidim/default-avatar.svg": 34157,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 595,
	"./decidim/icons.svg": 20316,
	"./decidim/pattern.png": 78879,
	"./decidim/placeholder-card-g.svg": 27940,
	"./decidim/placeholder-card-l.svg": 84767,
	"./decidim/placeholder.jpg": 16902,
	"./decidim/remixicon.symbol.svg": 37004,
	"./decidim/vendor/social-share-button/douban.svg": 19711,
	"./decidim/vendor/social-share-button/email.svg": 35963,
	"./decidim/vendor/social-share-button/facebook.svg": 6868,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 67968,
	"./decidim/vendor/social-share-button/hacker_news.svg": 90188,
	"./decidim/vendor/social-share-button/linkedin.svg": 50638,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 80647,
	"./decidim/vendor/social-share-button/pinterest.svg": 12454,
	"./decidim/vendor/social-share-button/reddit.svg": 40572,
	"./decidim/vendor/social-share-button/telegram.svg": 38001,
	"./decidim/vendor/social-share-button/tumblr.svg": 36974,
	"./decidim/vendor/social-share-button/twitter.svg": 22469,
	"./decidim/vendor/social-share-button/vkontakte.svg": 95575,
	"./decidim/vendor/social-share-button/wechat.svg": 69858,
	"./decidim/vendor/social-share-button/whatsapp.svg": 11938,
	"./decidim/vendor/social-share-button/x.svg": 55016,
	"./decidim/vendor/social-share-button/xing.svg": 25024
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40030;